module.exports = __webpack_public_path__ + "img/img-66.6562c0be.png";